// A readable device name for the session list, e.g. "Android · Chrome".
export function guessDeviceName(ua: string = navigator.userAgent): string {
  let os = '기기'
  if (/Android/i.test(ua)) {
    const m = /Android[^;)]*;\s*([^;)]+?)(?:\sBuild|\))/i.exec(ua)
    os = m?.[1] && !/^K$/i.test(m[1].trim()) ? `Android (${m[1].trim()})` : 'Android'
  } else if (/Windows/i.test(ua)) os = 'Windows'
  else if (/iPhone|iPad/i.test(ua)) os = 'iOS'
  else if (/Mac OS X/i.test(ua)) os = 'Mac'
  else if (/Linux/i.test(ua)) os = 'Linux'
  let browser = ''
  if (/SamsungBrowser/i.test(ua)) browser = '삼성 인터넷'
  else if (/Edg\//i.test(ua)) browser = 'Edge'
  else if (/Chrome\//i.test(ua)) browser = 'Chrome'
  else if (/Firefox\//i.test(ua)) browser = 'Firefox'
  else if (/Safari\//i.test(ua)) browser = 'Safari'
  const name = browser ? `${os} · ${browser}` : os
  return name.slice(0, 60)
}
